/**
 * 文章相关API接口
 */
import request from './request';
import { USE_MOCK } from './config';
/**
 * 获取文章列表
 */
export async function getArticleList(params) {
    if (USE_MOCK) {
        // 返回模拟数据
        return {
            list: [],
            total: 0,
            totalPages: 1,
            currentPage: 1
        };
    }
    return request.get('/article/list', { params });
}
/**
 * 根据分类获取文章
 */
export async function getArticlesByCategory(categoryId) {
    if (USE_MOCK) {
        return [];
    }
    return request.get(`/article/category/${categoryId}`);
}
/**
 * 根据标签获取文章
 */
export async function getArticlesByTag(tagName) {
    if (USE_MOCK) {
        return [];
    }
    return request.get(`/article/tag/${tagName}`);
}
/**
 * 获取文章详情
 */
export async function getArticleDetail(id) {
    if (USE_MOCK) {
        return {
            id: 0,
            title: '',
            excerpt: '',
            content: '',
            categoryName: '',
            categoryId: '',
            publishDate: '',
            viewCount: 0,
            likeCount: 0,
            commentCount: 0,
            tags: []
        };
    }
    return request.get(`/article/${id}`);
}
/**
 * 增加文章浏览数
 */
export async function incrementViewCount(id) {
    if (USE_MOCK) {
        return;
    }
    return request.post(`/article/${id}/view`);
}
/**
 * 点赞文章
 */
export async function toggleArticleLike(id) {
    if (USE_MOCK) {
        return 0;
    }
    return request.post(`/article/${id}/like`);
}
export async function getCategoryList() {
    if (USE_MOCK) {
        return [
            { id: 1, name: '技术博客' },
            { id: 2, name: '生活随笔' },
            { id: 3, name: '读书笔记' }
        ];
    }
    return request.get('/category/list');
}
/**
 * 获取文章简单列表（用于评论管理筛选）
 */
export async function getSimpleArticleList() {
    if (USE_MOCK) {
        return [];
    }
    return request.get('/article/simple-list');
}
/**
 * 获取首页分类分布
 */
export async function getCategoryDistribution() {
    if (USE_MOCK) {
        return [];
    }
    return request.get('/article/category-distribution');
}
